export const projects = [
  {
    slug: 'maney',
    name: '514 S Maney Ave',
    location: 'Downtown Murfreesboro, TN',
    status: 'current',
    featured: true,
    description: [
      'We are currently saving a sixty-year-old historic building in downtown Murfreesboro and transforming it into custom office space. The project involves a material amount of demo that had to be done carefully to save the exterior walls. The new space will have modern office space, a recording studio, a sound proof room with a state of the art projection system for screening videos and movies, as well as a wood working shop.',
    ],
  },
  {
    slug: 'vine-street',
    name: '633 E. Vine Street',
    location: 'Murfreesboro, TN',
    status: 'current',
    description: [
      'This project involves converting a former air traffic control school into a custom tattoo studio. The scope includes running new electrical, plumbing, and sewer lines and completely changing the space into a luxury studio.',
    ],
  },
  {
    slug: 'evergreen',
    name: 'Evergreen Cemetery',
    location: 'Murfreesboro, TN',
    status: 'current',
    description: [
      'We are excited to help this customer by creating a brand-new office space on their property. It requires creating a new drainage pond and then completing a 2,000 square foot office space which includes a fire proof room for the storage of important documentation.',
    ],
  },
  {
    slug: 'cooper-steel',
    name: 'Cooper Steel',
    location: 'Shelbyville, TN',
    status: 'current',
    description: [
      'At Cooper Steel, we are building out two new shops which includes a revamped workspace as well as new bathrooms.',
    ],
  },
  {
    slug: 'arnold-afb',
    name: 'Arnold Air Force Base',
    location: 'Tullahoma, TN',
    status: 'current',
    description: [
      'We are currently finishing a building remodel at the air base which requires careful planning with other contractors and the base to make sure everyone is always aligned on scope and timing.',
    ],
  },
  {
    slug: 'te-connectivity',
    name: 'TE Connectivity',
    location: 'Tennessee',
    status: 'recent',
    description: [
      'We recently completed a renovation of two commercial bathrooms at TE to give them an updated look and design while also minimizing disruption to their production.',
      'We have also completed other small efforts at TE including office remediations, emergency repairs to their cooling towers, the installation of a new gas heater, and the replacement of a set of commercial double doors.',
    ],
  },
  {
    slug: 'jack-daniels',
    name: 'Jack Daniels',
    location: 'Lynchburg, TN',
    status: 'recent',
    description: [
      'We had the pleasure of helping to restore a large section of the General Store in downtown Lynchburg. We have also done some smaller projects such as pouring a new pad for the grainery process and adding new fire rated doors to a production facility.',
    ],
  },
  {
    slug: 'harriman',
    name: 'Harriman Housing Authority',
    location: 'Harriman, TN',
    status: 'recent',
    description: [
      'The HHA needed us to roof 55 existing buildings which required stripping off the existing roofs and replacing them the same day. We had constant communication with the HHA to avoid inconveniencing the occupants. This project was completed in less than six weeks.',
    ],
  },
  {
    slug: 'franklin-county',
    name: 'Franklin County Housing Authority',
    location: 'Franklin County, TN',
    status: 'recent',
    description: [
      'The project scope included changing out the siding and parking lot lighting at three complexes in Franklin County.',
    ],
  },
];
